<template>
  
  <div id="app">
    <Header v-if="!$route.meta.hideNavigation" />
    
    <!-- <Header v-if="$route.name != 'Login' && $route.name != 'Welcome'" /> -->
    <router-view></router-view>

    <vue-progress-bar></vue-progress-bar>
    <!-- <PopUpChat></PopUpChat> -->
    <footer>
       
      <cookie-law theme="dark-lime">
      <div slot="message">
        This website uses cookies to ensure you get the best experience on our website.
        <a target="_blank" :href="'https://en.wikipedia.org/wiki/HTTP_cookie'">Know More</a>
      </div>
    </cookie-law>
    </footer>
  </div>
</template>
<script>
import Header from "@/components/Header";
import CookieLaw from 'vue-cookie-law';
// import PopUpChat from "@/components/PopUpChat";
export default {
  components: { 
    Header,CookieLaw  
    // PopUpChat 
  },
  data() {
    return {
      messaging : null,
    };
  },
  created() {
    this.$Progress.start();

    // //hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        //  start the progress bar
        this.$Progress.start();
        //  continue to next page
      }
      next();
    });
    // //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      //  finish the progress bar
      // console.log(to,from);
      setTimeout(() => {
        this.$Progress.finish();
      }, 1000);
    });

    //=============== Push Notification =====================//
    // const messaging = window.firebase.messaging();
    // messaging.getToken({vapidKey: window.vapidKey}).then((currentToken) => {
    //   if (currentToken) {
    //     localStorage.setItem("device_token",currentToken);
    //   } else {
    //       console.log("Permission required!");
    //   }
    // }).catch((err) => {
    //     console.log('An error occurred while retrieving token. ', err);
    // });

    // messaging.onMessage((payload) => {
    //   console.log(payload);
    //   this.$toasted.show(payload.notification.body,{
    //     icon : payload.data.success ? 'check-circle' : 'times-circle',
    //     className:payload.data.success ? 'success-class' : 'error-class'
    //   });
    // });
  },
  mounted() {
    this.$Progress.finish();
  },
  methods: {
    
  },
};
</script>
